

























































import Vue from "vue";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import ApplicationReadOnly from "../ApplicationReadOnly.vue";
import AgreementArticles from "../AgreementArticles.vue";

export default Vue.extend({
  components: { ApplicationReadOnly, AgreementArticles },
  name: "ApplicationStep7",

  props: {},

  data: () => {
    return {};
  },

  methods: {
    submitApplication() {
      this.$emit("submit-all");
    },
  },

  computed: {
    ...mapGetters({
      saving: types.SAVING_FORM,
      allFormValues: types.FORM_VALUES,
    }),
  },
});
